import { Link} from "react-router-dom";
import loginIcon from "../../imagenesLogin/login-icon.svg"
import usernameIcon from "../../imagenesLogin/username-icon.svg"
import vdpIcon from "../../imagenesLogin/VdpLogo.png"
import { useState } from "react";
import Error from "../Error";
import axios from "axios";
import API from '../utils/api';
import Alerta from "../Alerta";


const OlvidePassword = ()=>{
      const [mailOlvide, setMailOlvide] = useState("")
      const [alerta, setAlerta] = useState({})
      var url = API.urlAPI
      const urlOlvidePassword = url + "usuarios/olvide-password"
      console.log(urlOlvidePassword)

      const handleSubmit= async e=>{
        if(mailOlvide ==""){
          setAlerta({
            msg: 'Todos los campos son obligatorios',
            error: true
        });
            return
        }
        setAlerta({})
        try {
          console.log({"mail":mailOlvide})
          const {data} = await axios.post(urlOlvidePassword, {"mail":mailOlvide})
          setAlerta({
            msg: data.msg,
            error:false
          })
        } catch (error) {
          console.log(error)
          setAlerta({
            msg: error.response.data.msg,
            error:false
          })
       
        }
      }
      const { msg } = alerta
    return(
        <div className=" d-flex justify-content-center align-items-center mt-5">
        <div
          className="bg-white p-5 rounded-5 text-secondary shadow "
          style={{width: "25rem"}}
        >
          <div className="d-flex justify-content-center">
            <img
              src={vdpIcon}
              alt="login-icon"
              style={{height: "6rem"}}
            />
          </div>
          <div className="text-center fs-1 fw-bold">Recuperar contraseña</div>
          {msg && 
            <Alerta alerta={alerta}></Alerta>
          }
          <div className="input-group mt-4">
            <div className="input-group-text " style={{ background: "#005187" }}>
              <img
                src={usernameIcon}
                alt="username-icon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="email"
              placeholder="Mail"
              value={mailOlvide}
              onChange={e=>setMailOlvide(e.target.value)}
            />
          </div>
          <div className="btn  text-white w-100 mt-4 fw-semibold shadow-sm" onClick={handleSubmit} style={{ background: "#005187" }}>
            Recuperar
          </div>
        </div>
        </div>
    )
}

export default OlvidePassword